/**
 * PATH: packages/ui/src/components/mobile-dock/mobileDockChrome.ts
 * FILE_ID: MASTER-SHELL-MOBILEDOCK-CHROME-001
 * PURPOSE: People-directory palette tokens for the master hub MobileDock.
 * WHY: Teal/cyan active washes read as blue on the master shell (dashboard
 *   --primary is already blue). Operator asked to kill the blue dock chrome.
 * RELATED: TeamsHub People tokens; jobsPeopleTableChrome.ts.
 */

/** Outer pill shell — border/card tokens, not slate-200 islands. */
export const MOBILE_DOCK_SHELL =
  'rounded-2xl border border-border bg-card/95 backdrop-blur shadow-lg shadow-black/5'

/** Active hub/nav tile — accent wash, never teal/blue/primary fills. */
export const MOBILE_DOCK_TILE_ACTIVE =
  'bg-accent text-foreground no-underline'

/** Idle tile — muted text; hover uses the same accent family. */
export const MOBILE_DOCK_TILE_IDLE =
  'text-muted-foreground hover:bg-accent hover:text-accent-foreground no-underline'

/** Planned hub — stay quiet. */
export const MOBILE_DOCK_TILE_PLANNED =
  'text-muted-foreground hover:text-muted-foreground hover:bg-muted no-underline'

/** Development hub (idle) — amber status, not teal/blue. */
export const MOBILE_DOCK_TILE_DEV =
  'text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 no-underline'

export type MobileDockTileStatus = 'production' | 'development' | 'planned'

/** status + active -> tile class string (hub + nav share the active wash). */
export function mobileDockTileClasses(
  kind: 'nav' | 'hub' | 'utility',
  status: MobileDockTileStatus | undefined,
  active: boolean,
): string {
  if (kind === 'hub' && status === 'planned') return MOBILE_DOCK_TILE_PLANNED
  if (kind === 'hub' && status === 'development' && !active) return MOBILE_DOCK_TILE_DEV
  return active ? MOBILE_DOCK_TILE_ACTIVE : MOBILE_DOCK_TILE_IDLE
}
